module.exports = __webpack_public_path__ + "img/alert-inactive.fb664fdd.svg";